import { Component, OnInit } from '@angular/core';
import { Options } from '@angular-slider/ngx-slider';
import { Zone, ZoneLevel } from './range-scale.model';
import { BsModalRef } from 'ngx-bootstrap/modal';


@Component({
    selector: 'app-range-scale',
    templateUrl: './range-scale.component.html',
    styleUrls: ['./range-scale.component.css'],
    standalone: false
})
export class RangeScaleComponent implements OnInit {
  title?: string;
  description?: string;
  scaleTitle?: string;
  min!: number;
  max!: number;
  step!: number;
  zones: Zone[] = [];
  sliderOptions!: Options;

  constructor(private modalRef: BsModalRef) { }

  ngOnInit(): void {

    this.sliderOptions = {
      floor: this.min,
      ceil: this.max,
      step: this.step,
      showTicks: true,
      showTicksValues: true,
      tickStep: this.step,
      translate: (value: number): string => this.formatValue(value)
    };
  }

  closeModal() {
    this.modalRef.hide();
  }

  getZoneStyle(zone: Zone) {
    const total = this.max - this.min || 1;

    const leftPercent = ((zone.min - this.min) / total) * 100;
    const widthPercent = ((zone.max - zone.min) / total) * 100;

    return {
      left: `${leftPercent}%`,
      width: `${widthPercent}%`,
      backgroundColor: this.getColor(zone.level),
      borderRadius: '8px',
    };
  }

  private getColor(level: ZoneLevel) {
    switch (level) {
      case ZoneLevel.Danger:
        return '#f00';
      case ZoneLevel.Warning:
        return '#ffc500';
      case ZoneLevel.Safe:
        return '#00CE2C';
      default: return '#fff';
    }
  }

  private formatValue(value: number): string {
    let decimalPlaces = 0;
    if (this.step % 1 !== 0) {
      const stepParts = this.step.toString().split('.');
      decimalPlaces = stepParts[1].length;
    }
    return value.toFixed(decimalPlaces);
  }

}